<template><section><template>
<h3>Timeline</h3>
<div class="bs-docs-section">
<blockquote>
<p>Timeline (static)</p>
</blockquote>
<div class="bs-example">
<n3-timeline>
<n3-timeline-item color="#2ecc71" icon="check-circle-o">Create success</n3-timeline-item>
<n3-timeline-item color="#3498db">Approved</n3-timeline-item>
<n3-timeline-item color="#e74c3c" icon="times-circle-o">Abnormal</n3-timeline-item>
</n3-timeline>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline</span> &gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#2ecc71'</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"check-circle-o"</span>&gt;</span>Create success<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#3498db'</span>&gt;</span>Approved<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline-item</span> <span class="hljs-attr">color</span>=<span class="hljs-string">'#e74c3c'</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"times-circle-o"</span>&gt;</span>Abnormal<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline</span>&gt;</span>
</code></pre>
<blockquote>
<p>Timeline (data bind)</p>
</blockquote>
<div class="bs-example">
<n3-timeline :value="value">
</n3-timeline>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-timeline</span>
  <span class="hljs-attr">:value</span>=<span class="hljs-string">"value"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-timeline</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">value</span>: [{
        <span class="hljs-attr">icon</span>: <span class="hljs-string">'check-circle-o'</span>,
        <span class="hljs-attr">color</span>: <span class="hljs-string">'green'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">`&lt;a @click="del"&gt;Create success&lt;/a&gt;`</span>
      }, {
        <span class="hljs-attr">content</span>: <span class="hljs-string">'&lt;span&gt;Approved&lt;/span&gt;'</span>
      }, {
        <span class="hljs-attr">content</span>: <span class="hljs-string">'&lt;span&gt;Abnormal&lt;/span&gt;'</span>
      }]
    }
  },
  <span class="hljs-attr">methods</span>: {
    del () {
      alert(<span class="hljs-number">2</span>)
    }
  }
}
</code></pre>
<h3>Timeline Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td><code v-pre="">Array</code></td>
<td></td>
<td>value</td>
</tr>
</tbody>
</table>
<h3>TimelineItem Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>color</td>
<td><code v-pre="">String</code></td>
<td>#2db7f5</td>
<td>color</td>
</tr>
<tr>
<td>content</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>content</td>
</tr>
<tr>
<td>icon</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>icon</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: [{
        icon: 'check-circle-o',
        color: 'green',
        content: `<a @click="del">Create success</a>`
      }, {
        content: '<span>Approved</span>'
      }, {
        content: '<span>Abnormal</span>'
      }]
    }
  },
  methods: {
    del () {
      alert(2)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TimelineDocs.md?1f60b75d